import React from 'react'

import {
  DateTimeField,
  FieldSpec,
  PaginatedTable,
  RelatedLinkedField,
  UnitLocUnitField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key: string]: FieldSpec } = {
  asn: {
    id: 'asn',
    label: 'ASN',
    ordering: 'asn__tracking_number',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  receivedOn: {
    id: 'asn.receivedOn',
    label: 'Received On',
    ordering: 'asn__received_on',
    renderer: DateTimeField,
  },
  sku: {
    id: 'sku',
    label: 'SKU',
    ordering: 'sku__sku',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  productName: {
    id: 'sku.productName',
    label: 'Product Name',
    ordering: 'sku__product_name',
    renderer: ValueField,
  },
  product: {
    id: 'product',
    label: 'Product',
    ordering: 'product__name',
    renderer: RelatedLinkedField(ValueField, 'name'),
  },
  numUnits: {
    id: 'numUnits',
    label: 'Number of Units Received',
    ordering: 'num_units',
    renderer: UnitLocUnitField,
  },
  overage: { id: 'overage', label: 'Over', ordering: 'overage', renderer: UnitLocUnitField },
}

export const ASNUnitListTable = (props: ListTableProps) => {
  const { paginator, fields, title = 'Units in ASN', exportConfig } = props

  return (
    <>
      <PaginatedTable
        title={title}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
